const state = {
  listaDeDocumentosFavoritos: []
}

export default state
